import React from 'react';
import { SiteHeader, ActionMenuItem, FlosIcon, Link, Badge } from '@flos/react-ui';
import { useRecoilState, useRecoilValue } from 'recoil';
import { allCoverablesAtom } from '../../recoil/atoms/allCoverablesAtom';
import { allCoverablesOnsaAtom } from '../../recoil/atoms/allCoverablesOnsaAtom';
import { shoppingBasketOverlayAtom } from '../../recoil/atoms/shoppingBasketOverlayAtom';
import { externalLinks } from '../../strings';
import { numberOfCoverablesInShoppingBasket } from '../../pages/ShoppingBasketPage/utils/ShoppingBasketUtil';
import { businessFlowSelector } from '../../recoil/selectors/getBusinessFlowSelector';
import { wizardStepAtom } from '../../recoil/atoms/wizardAtom';
import { pageIndex } from '../../config/wizardPagesConfig';

const TopBar = (): React.JSX.Element => {
    const allCoverableDTO = useRecoilValue(allCoverablesAtom);
    const allCoverableOnsaDTO = useRecoilValue(allCoverablesOnsaAtom);
    const [shoppingBasketOverlayInfo, setShoppingBasketOverlayInfo] =
        useRecoilState(shoppingBasketOverlayAtom);
    const businessFlow = useRecoilValue(businessFlowSelector);
    const wizardStep = useRecoilValue(wizardStepAtom);

    const isBetweenShoppingBasketAndReceiptPage =
        wizardStep >= pageIndex('ShoppingBasketPage') && wizardStep <= pageIndex('ReceiptPage');
    const showBasketIcon = businessFlow === 'ONSA' && !isBetweenShoppingBasketAndReceiptPage;

    const numberOfCoverablesInBasket = numberOfCoverablesInShoppingBasket(
        allCoverableDTO,
        allCoverableOnsaDTO
    );

    const closeShoppingBasketOverlay = (): void => {
        if (numberOfCoverablesInBasket === 0) {
            window.open(externalLinks.topdanmarkDK, '_self');
        } else {
            setShoppingBasketOverlayInfo({
                isOverlayOpen: false,
                isButtonDisplayed: false
            });
        }
    };

    return (
        <>
            <SiteHeader logoHref="/" id="top-bar">
                <ActionMenuItem>
                    {shoppingBasketOverlayInfo.isOverlayOpen ? (
                        <button
                            className="site-header-menu-item-link"
                            onClick={closeShoppingBasketOverlay}
                        >
                            <span className="u-flex-box u-flex-box--center">
                                <Link className="visible-md visible-lg">Luk</Link>
                                <FlosIcon shape="close" size={32} />
                            </span>
                        </button>
                    ) : (
                        showBasketIcon && (
                            <button
                                className="site-header-menu-item-link"
                                onClick={() => {
                                    setShoppingBasketOverlayInfo({
                                        isOverlayOpen: true,
                                        isButtonDisplayed: false
                                    });
                                }}
                            >
                                <Link className="visible-md visible-lg">Se kurv</Link>
                                <FlosIcon shape="shopping_cart" size={32} />
                                <Badge
                                    id="badge-id"
                                    theme="primary"
                                    size="small"
                                    content={numberOfCoverablesInBasket.toString()}
                                    style={{
                                        position: 'absolute',
                                        top: -4,
                                        right: -4,
                                        display: 'block'
                                    }}
                                />
                            </button>
                        )
                    )}
                </ActionMenuItem>
            </SiteHeader>
        </>
    );
};

export { TopBar };
